// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".total[data-v-03220bb8]{font-size:16px;padding:25px 0;text-align:right;color:#666;margin-bottom:10px}.total .price[data-v-03220bb8]{color:#0079fe}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
